import React from 'react';
import { Container, Row, Col, Badge, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import moment from 'moment';

import * as commonFunc from 'scripts/common';

function WidgetBreadcrumb({
    srcData,
    srcTag,
    currentStatus,
    statusHistory = [],
    statusConfig = {},
    showDates = true,
    showTooltips = true,
    variant = 'horizontal', // 'horizontal' ou 'vertical'
    size = 'md', // 'sm', 'md', 'lg'
    statusOrder = ['nouveau', 'en_cours', 'tarifs_envoyes', 'visite_planifiee', 'visite_realisee', 'converti'],
    lastStatus,
    altCreateStatus
}) {

    // Fusionner la config par défaut avec celle fournie
    //const finalStatusConfig = { ...defaultStatusConfig, ...statusConfig };
    const finalStatusConfig = { ...statusConfig };
    Object.keys(finalStatusConfig).forEach(keyConfig => {
        if (!keyConfig.endsWith("tooltip")) {
            var statusObj = finalStatusConfig[keyConfig];
            if (!statusObj.bgColor && statusObj.css) {
                switch (true) {
                    case statusObj.css.indexOf("purple-300") >= 0:
                        statusObj.bgColor = "#BA68c8";
                        break;
                    case statusObj.css.indexOf("amber-600") >= 0:
                        statusObj.bgColor = "#ffb300";
                        break;
                    case statusObj.css.indexOf("cyan-600") >= 0:
                        statusObj.bgColor = "#00acc1";
                        break;
                    case statusObj.css.indexOf("green-400") >= 0:
                        statusObj.bgColor = "#66bb6a";
                        break;


                    case statusObj.css.indexOf("bg-danger") >= 0:
                        statusObj.bgColor = "#DC3545";
                        break;
                    case statusObj.css.indexOf("bg-success") >= 0:
                        statusObj.bgColor = "#198754";
                        break;
                    case statusObj.css.indexOf("bg-primary") >= 0:
                        statusObj.bgColor = "#0D6EFD";
                        break;
                    case statusObj.css.indexOf("bg-secondary") >= 0:
                        statusObj.bgColor = "#6C757D";
                        break;
                    case statusObj.css.indexOf("bg-info") >= 0:
                        statusObj.bgColor = "#0DCAF0";
                        break;
                    case statusObj.css.indexOf("bg-warning") >= 0:
                        statusObj.bgColor = "#FFC107";
                        break;
                    default:
                        break;
                }
            }
            //if (!statusObj.textColor) statusObj.textColor = "#000000";
            if (!statusObj.textColor) statusObj.textColor = statusObj.bgColor;


            var classFa = "";
            if (statusObj.css?.indexOf("fa-")) {
                statusObj.css.split(" ").forEach((classElem) => {
                    //console.debug(classElem.startsWith("fa-") + classElem);
                    classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                });
                if (classFa) statusObj.icon = "fa " + classFa;
            }
        }
    });

    // Créer un mapping des statuts avec leurs dates
    var statusDates = {};
    statusHistory.forEach(entry => {
        if (entry.title === "UpdateStatus") statusDates[entry.statutID] = entry;
        else if (entry.title === "Add") statusDates["create"] = entry;
    });

    // Déterminer l'index du statut actuel
    var lostIDs = lastStatus || [statusOrder[statusOrder.length - 1]];
    var lostID = currentStatus;
    var isCurrentLost = lostIDs.indexOf(currentStatus) >= 0;
    var currentIndex = statusOrder.indexOf(currentStatus);

    // Fonction pour formater les dates
    const formatDate = (dateString) => {
        /*if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });*/
        var mDate = dateString ? commonFunc.restStringToDate(dateString) : null;
        if (commonFunc.isValidDate(mDate) && mDate.getFullYear() > 1 && mDate.getFullYear() !== 1969 && mDate.getFullYear() !== 1970 && mDate.getFullYear() !== 2100 /*&& mDate.getFullYear() > 1970*/) {
            return commonFunc.formatDateTime(moment(mDate).utc(true).toDate());
        }
        else return '';
    };

    // Fonction pour formater l'heure
    const formatTime = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Déterminer la taille des éléments selon la prop size
    const getSizeClasses = () => {
        switch (size) {
            case 'sm':
                return {
                    circle: { width: "40px", height: "40px" },
                    icon: '14px',
                    text: '12px',
                    badge: '10px'
                };
            case 'lg':
                return {
                    circle: { width: "60px", height: "60px" },
                    icon: '20px',
                    text: '16px',
                    badge: '12px'
                };
            default: // md
                return {
                    circle: { width: "50px", height: "50px" },
                    icon: '16px',
                    text: '14px',
                    badge: '11px'
                };
        }
    };

    const sizeClasses = getSizeClasses();

    // Rendu du breadcrumb horizontal
    const renderHorizontalBreadcrumb = () => (
        <div className="position-relative">
            {/* Ligne de connexion principale */}
            <div
                className="position-absolute bg-light"
                style={{
                    top: '25px',
                    left: '25px',
                    right: '25px',
                    height: '0px',
                    border: '1px dashed grey',
                    transform: 'translateY(-50%)',
                    zIndex: 1
                }}
            />

            <Row className="align-items-center justify-content-between position-relative" style={{ zIndex: 2 }}>
                {statusOrder.map((statusOrderID, index) => {
                    if (lastStatus.indexOf(statusOrderID) >= 0) return "";
                    const statusObj = finalStatusConfig[statusOrderID] || {};
                    const flowObj = statusDates[statusOrderID] || (altCreateStatus.indexOf(statusOrderID) >= 0 ? statusDates["create"] : null);
                    const isCurrent = statusOrderID === currentStatus;
                    const isPast = index < currentIndex && !isCurrent;
                    const isFuture = index > currentIndex && !flowObj;

                    var nextColor = finalStatusConfig[statusOrder[index + 1]]?.bgColor;

                    var statusBgColor = statusObj.bgColor;
                    var statusTextColor = statusObj.textColor;
                    if (isCurrentLost) {
                        statusBgColor = finalStatusConfig[lostID].bgColor;
                        statusTextColor = finalStatusConfig[lostID].textColor;
                        nextColor = finalStatusConfig[lostID].textColor;
                    }

                    return (
                        <Col id={"statusblock" + srcTag + statusOrderID} key={statusOrderID} className="text-center position-relative">
                            {/* Ligne de connexion colorée pour les étapes passées */}
                            {index < statusOrder.length - 1 && isPast ?
                                <div
                                    className={`position-absolute`}
                                    style={{
                                        top: '25px',
                                        left: '50%',
                                        width: '100%',
                                        height: '3px',
                                        background: `linear-gradient(to right, ${statusBgColor}, ${nextColor || '#6c757d'})`,
                                        transform: 'translateY(-50%)',
                                        zIndex: 1
                                    }}
                                />
                            : ""}

                            {/* Cercle du statut */}
                            <div
                                className={`rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2 ${isCurrent ? 'shadow-lg' : isPast ? 'shadow' : ''
                                    } ${/*(isCurrent || isPast) ? statusObj.css.replace("badge", "") : */""}`}
                                style={{
                                    ...sizeClasses.circle,
                                    backgroundColor: (isCurrent || isCurrentLost) ? statusBgColor : isPast ? '#007bffAA' : '#e9ecef',
                                    border: `3px solid ${(isCurrent || isCurrentLost) ? statusBgColor : isPast ? '#007bffAA' : '#dee2e6'}`,
                                    color: isCurrent || isPast ? 'white' : '#6c757d',
                                    transform: isCurrent ? 'scale(1.1)' : 'scale(1)',
                                    transition: 'all 0.3s ease',
                                    zIndex: 3,
                                    position: 'relative'
                                }}
                                title={showTooltips && flowObj ? flowObj.note : ''}
                            >
                                <i className={`${(flowObj || index === 0) && isPast && !isCurrent ? statusObj.icon : statusObj.icon}`}
                                    style={{ fontSize: sizeClasses.icon }}
                                />

                                {/* Ring pour le statut actuel */}
                                {isCurrent && (
                                    <div
                                        className="position-absolute rounded-circle"
                                        style={{
                                            top: '-6px',
                                            left: '-6px',
                                            right: '-6px',
                                            bottom: '-6px',
                                            border: `3px solid ${statusBgColor}30`,
                                            animation: 'pulse 2s infinite'
                                        }}
                                    />
                                )}
                            </div>

                            {/* Label et informations */}
                            <div style={{ minHeight: '120px' }}>
                                <div
                                    className={`fw-bold mb-1 ${(isCurrent || isCurrentLost) ? '' : isPast ? 'text-primary' : 'text-muted'
                                        }`}
                                    style={{
                                        fontSize: sizeClasses.text,
                                        color: (isCurrent || isCurrentLost) ? statusTextColor : undefined
                                    }}
                                >
                                    {statusObj.name}
                                </div>

                                {flowObj && showDates && (
                                    <div className="text-muted justify-items-center" style={{ fontSize: sizeClasses.badge }}>
                                        <div>{flowObj.tenantUserAccess?.name}</div>
                                        <div>{formatDate(flowObj.dSysMod)}</div>
                                    </div>
                                )}

                                {isCurrent && (
                                    <Badge
                                        className={`mt-1 ${/*statusObj.css.replace("fa-", "untrigger")*/ ""}`} color={"light"}
                                        style={{ fontSize: sizeClasses.badge, color: statusTextColor, border: "1px solid " + statusBgColor }}
                                    >
                                        Actuel
                                    </Badge>
                                )}

                                {isFuture && (
                                    <div className="text-muted fst-italic" style={{ fontSize: sizeClasses.badge }}>
                                        À venir
                                    </div>
                                )}
                            </div>
                            {finalStatusConfig[statusOrderID + "tooltip"]?.value?.length && finalStatusConfig[statusOrderID + "tooltip"].value.filter(cfg => !commonFunc.isBlank(cfg)).length ? <UncontrolledPopover
                                fade
                                target={"statusblock" + srcTag + statusOrderID}
                                placement="auto"
                                trigger="hover"
                                container="body"
                                delay={{ show: 500, hide: 50 }}
                            //noIncluded="html: true"//INFO
                            >
                                <PopoverHeader>{finalStatusConfig[statusOrderID + "tooltip"].title}</PopoverHeader>
                                <PopoverBody>
                                    {finalStatusConfig[statusOrderID + "tooltip"].value.map((val, index) => <div key={statusOrderID + "-" + index}>{val}</div>)}
                                </PopoverBody>
                            </UncontrolledPopover> : ""}
                        </Col>
                    );
                })}

                {/* Indicateur pour les leads perdus */}
                {isCurrentLost && (
                    <Col id={"statusblock" + srcTag + lostID} className="text-center">
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2 shadow-lg"
                            style={{
                                ...sizeClasses.circle,
                                backgroundColor: finalStatusConfig[lostID].bgColor,
                                border: `3px solid ${finalStatusConfig[lostID].bgColor}`,
                                color: 'white',
                                transform: 'scale(1.1)',
                                transition: 'all 0.3s ease',
                                zIndex: 3,
                                position: 'relative'
                            }}
                            title={showTooltips && statusDates[lostID] ? statusDates[lostID].note : ''}
                        >
                            <i className={`${finalStatusConfig[lostID].icon}`}
                                style={{ fontSize: sizeClasses.icon }}
                            />

                            <div
                                className="position-absolute rounded-circle"
                                style={{
                                    top: '-6px',
                                    left: '-6px',
                                    right: '-6px',
                                    bottom: '-6px',
                                    border: `3px solid ${finalStatusConfig[lostID].bgColor}30`,
                                    animation: 'pulse 2s infinite'
                                }}
                            />
                        </div>

                        <div style={{ minHeight: '120px' }}>
                            <div className="fw-bold mb-1" style={{ fontSize: sizeClasses.text, color: finalStatusConfig[lostID].textColor }}>
                                {finalStatusConfig[lostID].name}
                            </div>
                            {statusDates[lostID] && showDates && (
                                <div className="text-muted justify-items-center" style={{ fontSize: sizeClasses.badge }}>
                                    <div>{statusDates[lostID].tenantUserAccess?.name}</div>
                                    <div>{formatDate(statusDates[lostID].dSysMod)}</div>
                                </div>
                            )}
                        </div>
                        {finalStatusConfig[lostID + "tooltip"]?.value ? <UncontrolledPopover
                            fade
                            target={"statusblock" + srcTag + lostID}
                            placement="auto"
                            trigger="hover"
                            container="body"
                            delay={{ show: 500, hide: 50 }}
                        //noIncluded="html: true"//INFO
                        >
                            <PopoverHeader>{finalStatusConfig[lostID + "tooltip"].title}</PopoverHeader>
                            <PopoverBody>
                                {finalStatusConfig[lostID + "tooltip"].value}
                            </PopoverBody>
                        </UncontrolledPopover> : ""}
                    </Col>
                )}
            </Row>
        </div>
    );

    // Rendu du breadcrumb vertical
    const renderVerticalBreadcrumb = () => (
        <div className="position-relative">
            {/* Ligne verticale de connexion */}
            <div
                className="position-absolute bg-light"
                style={{
                    top: '25px',
                    bottom: '25px',
                    left: '24px',
                    width: '2px',
                    zIndex: 1
                }}
            />

            {statusOrder.map((status, index) => {
                const config = finalStatusConfig[status];
                const hasReached = statusDates[status];
                const isCurrent = status === currentStatus && !isCurrentLost;
                const isPast = hasReached && !isCurrent && !isCurrentLost;
                const isFuture = !hasReached && !isCurrentLost;

                return (
                    <Row key={status} className="mb-4 align-items-center position-relative" style={{ zIndex: 2 }}>
                        <Col xs="auto">
                            {/* Cercle du statut */}
                            <div
                                className={`rounded-circle d-flex align-items-center justify-content-center ${isCurrent ? 'shadow-lg' : isPast ? 'shadow' : ''
                                    }`}
                                style={{
                                    ...sizeClasses.circle,
                                    backgroundColor: isCurrent ? config.bgColor : isPast ? '#007bff' : '#e9ecef',
                                    border: `3px solid ${isCurrent ? config.bgColor : isPast ? '#007bff' : '#dee2e6'}`,
                                    color: isCurrent || isPast ? 'white' : '#6c757d',
                                    transform: isCurrent ? 'scale(1.1)' : 'scale(1)',
                                    transition: 'all 0.3s ease',
                                    position: 'relative'
                                }}
                                title={showTooltips && hasReached ? statusDates[status].note : ''}
                            >
                                <i className={`${isPast && !isCurrent ? "fa fa-check-circle" : config.icon}`}
                                    style={{ fontSize: sizeClasses.icon }}
                                />

                                {isCurrent && (
                                    <div
                                        className="position-absolute rounded-circle"
                                        style={{
                                            top: '-6px',
                                            left: '-6px',
                                            right: '-6px',
                                            bottom: '-6px',
                                            border: `3px solid ${config.bgColor}30`,
                                            animation: 'pulse 2s infinite'
                                        }}
                                    />
                                )}
                            </div>
                        </Col>

                        <Col>
                            <div
                                className={`fw-bold ${isCurrent ? '' : isPast ? 'text-primary' : 'text-muted'
                                    }`}
                                style={{
                                    fontSize: sizeClasses.text,
                                    color: isCurrent ? config.textColor : undefined
                                }}
                            >
                                {config.label}
                                {isCurrent && (
                                    <Badge
                                        bg={config.color}
                                        className="ms-2"
                                        style={{ fontSize: sizeClasses.badge }}
                                    >
                                        Actuel
                                    </Badge>
                                )}
                            </div>

                            {hasReached && showDates && (
                                <div className="text-muted mt-1" style={{ fontSize: sizeClasses.badge }}>
                                    {formatDate(statusDates[status].dSysMod)} à {formatTime(statusDates[status].dSysMod)}
                                </div>
                            )}

                            {hasReached && statusDates[status].note && (
                                <div className="text-muted mt-1" style={{ fontSize: sizeClasses.badge }}>
                                    {statusDates[status].note}
                                </div>
                            )}

                            {isFuture && (
                                <div className="text-muted fst-italic" style={{ fontSize: sizeClasses.badge }}>
                                    À venir
                                </div>
                            )}
                        </Col>
                    </Row>
                );
            })}

            {/* Lead perdu en vertical */}
            {isCurrentLost && (
                <Row className="mb-4 align-items-center">
                    <Col xs="auto">
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center shadow-lg"
                            style={{
                                ...sizeClasses.circle,
                                backgroundColor: finalStatusConfig.perdu.bgColor,
                                border: `3px solid ${finalStatusConfig.perdu.bgColor}`,
                                color: 'white'
                            }}
                        >
                            <i className={`${finalStatusConfig.perdu.icon}`}
                                style={{ fontSize: sizeClasses.icon }}
                            />
                        </div>
                    </Col>

                    <Col>
                        <div className="fw-bold text-danger" style={{ fontSize: sizeClasses.text }}>
                            {finalStatusConfig.perdu.label}
                        </div>
                        {statusDates.perdu && showDates && (
                            <div className="text-muted mt-1" style={{ fontSize: sizeClasses.badge }}>
                                {formatDate(statusDates.perdu.dSysMod)} à {formatTime(statusDates.perdu.dSysMod)}
                            </div>
                        )}
                        {statusDates.perdu?.note && (
                            <div className="text-muted mt-1" style={{ fontSize: sizeClasses.badge }}>
                                {statusDates.perdu.note}
                            </div>
                        )}
                    </Col>
                </Row>
            )}
        </div>
    );

    return (
        <Container fluid className="p-0">
            <style>
                {`
                  @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.5; }
                  }
                `}
            </style>

            {variant === 'vertical' ? renderVerticalBreadcrumb() : renderHorizontalBreadcrumb()}
        </Container>
    );
};

export default WidgetBreadcrumb;

// Exemple d'utilisation :
/*
import WidgetBreadcrumb from './WidgetBreadcrumb';

const ExampleUsage = () => {
  const statusHistory = [
    { status: "nouveau", date: "2024-06-20T10:00:00", note: "Premier contact établi" },
    { status: "en_cours", date: "2024-06-22T14:30:00", note: "Analyse des besoins" },
    { status: "tarifs_envoyes", date: "2024-06-25T16:45:00", note: "Devis envoyé par email" }
  ];

  const customStatusConfig = {
    nouveau: { 
      label: "Nouveau Contact", 
      icon: faUser, 
      color: "primary",
      bgColor: "#007bff",
      textColor: "#0056b3"
    }
    // ... autres statuts personnalisés
  };

  return (
    <WidgetBreadcrumb
      currentStatus="tarifs_envoyes"
      statusHistory={statusHistory}
      statusConfig={customStatusConfig}
      showDates={true}
      showTooltips={true}
      variant="horizontal" // ou "vertical"
      size="md" // "sm", "md", ou "lg"
    />
  );
};
*/